import { useState, useEffect } from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { BarChart, Bar, XAxis, ResponsiveContainer } from 'recharts';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('nx_token')}` } });

export default function CreatorLinkedInRevenuePage() {
  const [commerce, setCommerce] = useState(null);
  const [liType, setLiType] = useState('brand_partnership');
  const [liAmount, setLiAmount] = useState('');
  const [liBrand, setLiBrand] = useState('');

  const load = () => axios.get(`${API}/creator/commerce-hub`, auth()).then(r => setCommerce(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    if (!liAmount) return;
    try { await axios.post(`${API}/creator/linkedin-revenue?amount=${liAmount}&entry_type=${liType}&brand_name=${encodeURIComponent(liBrand)}`, {}, auth()); toast.success('Entry added'); setLiAmount(''); setLiBrand(''); load(); }
    catch { toast.error('Failed'); }
  };

  const li = commerce?.linkedin_revenue;
  return (
    <DashboardLayout>
      <div className="space-y-5" data-testid="creator-linkedin-revenue">
        <div>
          <h1 className="font-display text-2xl font-black text-[var(--text-primary)] tracking-tight">LinkedIn Revenue</h1>
          <p className="text-sm text-[var(--text-secondary)] mt-1">Log B2B income — brand deals, consulting, speaking, product sales</p>
        </div>
        <div className="nx-metric-card rounded-md">
          <div className="flex items-center gap-3 mb-3">
            {['brand_partnership', 'consulting', 'speaking', 'product_course'].map(t => (
              <button key={t} onClick={() => setLiType(t)} className={`px-2.5 py-1 text-[9px] font-mono rounded ${liType === t ? 'bg-[var(--success)] text-white' : 'bg-[var(--neutral-bg)] text-[var(--text-tertiary)]'}`}>{t.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</button>
            ))}
          </div>
          <div className="flex items-center gap-2 mb-3">
            <Input value={liAmount} onChange={e => setLiAmount(e.target.value)} type="number" placeholder="INR" className="bg-[var(--surface-sunken)] border-[var(--border)] text-[var(--text-primary)] font-mono text-[10px] w-24" />
            <Input value={liBrand} onChange={e => setLiBrand(e.target.value)} placeholder="Client / Brand" className="bg-[var(--surface-sunken)] border-[var(--border)] text-[var(--text-primary)] text-[10px] flex-1" />
            <Button size="sm" onClick={handleAdd} className="bg-[var(--success)] text-white text-[9px] h-8 px-3">Add Entry</Button>
          </div>
          {li && <p className="text-xs text-[var(--text-primary)] font-mono mb-2">This month: <b className="text-[var(--success)]">INR {(li.total_this_month || 0).toLocaleString()}</b></p>}
          {li?.monthly_trend?.length > 0 && (
            <div className="h-24 mb-2"><ResponsiveContainer width="100%" height="100%"><BarChart data={li.monthly_trend}><XAxis dataKey="month" tick={{ fill: 'var(--text-tertiary)', fontSize: 8 }} axisLine={false} /><Bar dataKey="amount" fill="var(--success)" radius={[3, 3, 0, 0]} /></BarChart></ResponsiveContainer></div>
          )}
          {li?.insight && <p className="text-[8px] text-[var(--info)] italic">{li.insight}</p>}
          {li?.entries?.length > 0 && (
            <table className="w-full text-[9px] font-mono border-collapse mt-2">
              <thead><tr className="border-b border-[var(--border)] text-[var(--text-tertiary)]"><th className="text-left p-1">Date</th><th className="p-1">Type</th><th className="p-1">Client</th><th className="text-right p-1">Amount</th></tr></thead>
              <tbody>{li.entries.slice(0, 10).map(e => (<tr key={e.id} className="border-b border-[var(--border-light)]"><td className="p-1 text-[var(--text-secondary)]">{e.date}</td><td className="p-1 capitalize">{e.type?.replace(/_/g, ' ')}</td><td className="p-1 text-[var(--text-primary)]">{e.brand_name}</td><td className="p-1 text-right text-[var(--success)]">INR {e.amount?.toLocaleString()}</td></tr>))}</tbody>
            </table>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
